/** @jsx h */

import { h, Component } from 'preact';
import enhanceWithClickOutside from 'react-click-outside';
import Menu, { Item as MenuItem } from 'rc-menu';
import sortIcon from '../../../assets/icons/sortIcon.png';
import 'rc-menu/assets/index.css';
import style from './style.scss';

class DropDown extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selected: this.findSelected(props),
      showMenu: false,
    };
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.selected !== this.props.selected) {
      this.setState({
        selected: this.findSelected(nextProps),
      });
    }
  }

  findSelected = (props) => props.data.find((item) => item.value === props.selected || item === props.selected)
      || props.data.find(((item) => item.value === ''));

  onSelect = (e) => {
    this.props.onChange(e.key === 'item_0' ? '' : e.key);
  };

  openMenu = () => {
    const { showMenu } = this.state;
    this.setState({
      showMenu: !showMenu,
    });
  }

  render({ data, className = '', showIcon = true }, { selected, showMenu }) {
    return (
      <div onClick={this.openMenu} className={`${className} ${style.dropdown}`}>
        <div className={`${selected.value === '' ? style.placeholder : ''} ${style.selected}`}>
          {
            showIcon && (
              <img src={sortIcon} alt="" />
            )
          }
          {selected.name || selected}
        </div>
        {
          showMenu && (
            <div className={style.menu}>
              <Menu onSelect={this.onSelect} activeKey={selected.value !== undefined ? selected.value : selected}>
                {data.map((item, index) => index !== 0 && <MenuItem key={item.value !== undefined ? item.value : item}>{item.name || item}</MenuItem>)}
              </Menu>
            </div>
          )
        }
      </div>
    );
  }
}


export default enhanceWithClickOutside(DropDown);



// WEBPACK FOOTER //
// ./components/search/dropdown/index.js